import { PreviewsStatus, type PreviewsStatusProps } from '@components/shared/BudgetPreviewsStatus/types'

const GU_EDITABLE_PREVIEW_STATUSES: PreviewsStatusProps[] = [
  PreviewsStatus.IN_PROGRESS,
  PreviewsStatus.RETURNED_GU,
  PreviewsStatus.RELEASED
]

interface GetModalPermissionsParams {
  isGuProfile: boolean
  canEditPagePermission: boolean
  canEditFromParent: boolean
  currentPreviewStatus?: PreviewsStatusProps
  isFirstWeekNotStarted: boolean
  isFirstWeekReturnedGu?: boolean
  isFirstWeekInProgress?: boolean
  apiCanEdit?: boolean
  hasCompleteDistribution?: boolean
  items?: { valorDias?: unknown[] | null }[] | null
  canRestoreForecast?: boolean
}

export interface ModalPermissions {
  canEditOverall: boolean
  canEditWeeks: boolean
  canEditStartDate: boolean
  canDistribute: boolean
  canAddService: boolean
  canAddOtherService: boolean
  hasDistributedBilling: boolean
}

export const getModalPermissions = ({
  isGuProfile,
  canEditPagePermission,
  canEditFromParent,
  currentPreviewStatus,
  isFirstWeekNotStarted,
  isFirstWeekReturnedGu,
  isFirstWeekInProgress,
  apiCanEdit,
  hasCompleteDistribution,
  items,
  canRestoreForecast
}: GetModalPermissionsParams): ModalPermissions => {
  const hasDistributedBilling =
    hasCompleteDistribution === true || !!items?.[0]?.valorDias?.length || canRestoreForecast === true
  const hasItems = !!items?.length

  const isEditableState = !!currentPreviewStatus && GU_EDITABLE_PREVIEW_STATUSES.includes(currentPreviewStatus)
  const isPartiallyDistributed = isFirstWeekNotStarted && apiCanEdit === true

  const base = isGuProfile && canEditPagePermission && canEditFromParent

  const canEditWeeks = base && (isEditableState || isPartiallyDistributed)
  const canEditOverall = base && (isEditableState || isFirstWeekNotStarted || isPartiallyDistributed)

  // Janela de lançamento: semana 1 em not_started, returned_gu ou in_progress, e apenas
  // enquanto o cliente não tem faturamento distribuído. Restaurar a previsão limpa
  // hasDistributedBilling e reabre a janela.
  const isBillingWindowOpen =
    (isFirstWeekNotStarted || isFirstWeekReturnedGu === true || isFirstWeekInProgress === true) &&
    !hasDistributedBilling

  const canOpenBilling = base && isBillingWindowOpen

  return {
    canEditOverall,
    canEditWeeks,
    canEditStartDate: canOpenBilling,
    canDistribute: canOpenBilling && hasItems,
    canAddService: canEditWeeks,
    canAddOtherService: canEditWeeks && hasDistributedBilling,
    hasDistributedBilling
  }
}
